import Vue from 'vue';
import SERVICE_CONSTANTS from '@/constants/services';
import { mapGetters } from 'vuex';
export default Vue.extend({
    name: 'mobNavigationBar',
    data: () => ({}),
    props: {
        disabled: {
            type: Boolean
        }
    },
    computed: Object.assign({ showTraderDiary() {
            var _a;
            return Boolean((_a = this.getFeatureFlags['trader-diary']) === null || _a === void 0 ? void 0 : _a.isActive);
        }, navList() {
            return [
                { to: { name: 'mainPage' } },
                { to: { name: 'spotTrade', isOut: true, link: SERVICE_CONSTANTS.NEW_BINANCE + '/spot' } },
                { to: { name: 'leveragesPage', isOut: true, link: SERVICE_CONSTANTS.NEW_BINANCE + '/leverages' } },
                { to: { name: 'apiKeys', isOut: true, link: SERVICE_CONSTANTS.NEW_BINANCE + '/api-keys' } },
                ...(this.showTraderDiary
                    ? [{ to: { name: 'traderDiary', isOut: true, link: 'https://diary.whitelist.capital' } }]
                    : [])
            ];
        } }, mapGetters('mainPageModules', ['getFeatureFlags']))
});
